import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import classNames from 'classnames';

import styles from '../styles/sitemap.scss';

function getItemTitle(item) {
    return item.linkUrl ? (
        <Link href={item.linkUrl} className={styles.titleLink}>
            {item.title}
        </Link>
    ) : (
        item.title
    );
}

function displayItemsList(items = []) {
    return (
        <ul className={classNames('rowFlex', styles.l3Level)}>
            {items.map(item => {
                return (
                    <li className="colLg3" key={item.label} data-linkstype="vertical">
                        <Link
                            href={item.linkUrl}
                            className={`${styles.link}`}
                            data-tn={`sitemap-list-link-${item.label}`}
                        >
                            {item.title}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
}
function renderItems(items) {
    // it will iterate over all verticals
    // each array will have items list
    return items.map(item => {
        const links = item.items || [];
        return (
            <div key={`${item.title}-${item.linksType}`}>
                <h2 className={classNames(styles.titleHeader, styles.fullRow)}>
                    {getItemTitle(item)}
                </h2>
                {links.map((link, index) => (
                    <div
                        className={styles.fullRow}
                        key={link.title}
                        data-tn={`sitemap-full-list-${index + 1}`}
                    >
                        <h3 className={styles.l3header}>{getItemTitle(link)}</h3>
                        {displayItemsList(link.items)}
                    </div>
                ))}
            </div>
        );
    });
}

export const SitemapNestedComponent = ({ sitemap }) => {
    const { sitemapLinks } = sitemap;
    return (
        <Fragment>
            <h1 className={styles.sitemapMainHeader}>
                <FormattedMessage id="sitemap.nested.header" defaultMessage="Sitemap" />
            </h1>
            {renderItems(sitemapLinks)}
        </Fragment>
    );
};
SitemapNestedComponent.propTypes = {
    sitemap: PropTypes.object.isRequired,
};

export const SitemapNested = createFragmentContainer(SitemapNestedComponent, {
    sitemap: graphql`
        fragment SitemapNested_sitemap on Sitemap {
            sitemapLinks {
                title
                linksType
                linkUrl
                items {
                    title
                    linkUrl
                    items {
                        title
                        label
                        linkUrl
                    }
                }
            }
        }
    `,
});
